import Q2_2 from './Q2_2';

export default Q2_2;
